import { useForumType } from '@/components/hooks/useForumType';
import React from "react";
import { isNewUser } from "../../lib/collections/users/helpers";
import { siteNameWithArticleSetting } from "../../lib/instanceSettings";
import { isFriendlyUI } from "../../themes/forumTheme";
import LWTooltip from "../common/LWTooltip";
import ForumIcon from "../common/ForumIcon";
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';

const styles = defineStyles("UserCommentMarkers", (theme: ThemeType) => ({
  iconWrapper: {
    margin: "0 3px",
  },
  postAuthorIcon: {
    verticalAlign: "text-bottom",
    color: theme.palette.grey[500],
    fontSize: 16,
  },
  sproutIcon: {
    position: "relative",
    bottom: -2,
    color: theme.palette.icon.sprout,
    fontSize: 16,
  },
}));

const UserCommentMarkers = ({user, isPostAuthor, className}: {
  user?: UsersMinimumInfo|null,
  isPostAuthor?: boolean,
  className?: string,
}) => {
  const { forumType } = useForumType();
  const classes = useStyles(styles);

  if (!user) {
    return null;
  }

  const showAuthorIcon = isFriendlyUI() && isPostAuthor;
  const showNewUserIcon = isNewUser(user, forumType);

  if (!showAuthorIcon && !showNewUserIcon) {
    return null;
  }
  return (
    <span className={className}>
      {showAuthorIcon &&
        <LWTooltip
          placement="bottom-start"
          title="Post author"
          className={classes.iconWrapper}
        >
          <ForumIcon icon="Author" className={classes.postAuthorIcon} />
        </LWTooltip>
      }
      {showNewUserIcon &&
        <LWTooltip
          placement="bottom-start"
          title={`${user.displayName} is either new on ${siteNameWithArticleSetting.get(forumType)} or doesn't have much karma yet.`}
          className={classes.iconWrapper}
        >
          <ForumIcon icon="Sprout" className={classes.sproutIcon} />
        </LWTooltip>
      }
    </span>
  );
}

export default UserCommentMarkers;


